import { render, staticRenderFns } from "./GetFlashSale.vue?vue&type=template&id=748db23e&"
import script from "./GetFlashSale.vue?vue&type=script&lang=js&"
export * from "./GetFlashSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports